import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Modal } from '.';

interface IModalColumnsProps {
  id: string;
  onClose: () => void;
  size?: string;
  hideFooter?: boolean;
  title?: string;
  children?: React.ReactNode;
  supportingColumn?: React.ReactNode;
}

const ModalColumns = (props: IModalColumnsProps) => {
  const { id, onClose, size = '4xl', hideFooter = true, title, children, supportingColumn } = props;

  return (
    <Modal id={id} show={true} title={title} onClose={onClose} size={size} hideFooter={hideFooter}>
      <Flex id="innerModal" flexDirection={{ base: 'column', md: 'row' }} columnGap={8} rowGap={6}>
        {supportingColumn ? <Box as="aside">{supportingColumn}</Box> : null}

        <Box as="article" order={{ base: 1, md: -1 }} minWidth={'50%'}>
          {children}
        </Box>
      </Flex>
    </Modal>
  );
};

export { ModalColumns };
